import InfoSection from "./info-section.js";
export default InfoSection;
